import {BrowserModule, Title} from "@angular/platform-browser";
import {LOCALE_ID, NgModule} from "@angular/core";
import {AppComponent} from "./app.component";
import {HttpModule} from "@angular/http";
import {HttpService} from "./_service/http.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AuthGuard} from "./_guards/auth.guard";
import {MainRoutingModule} from "./app.routing";
import {PasswordService} from "./password.service";
import {TmpNameModule} from "./tmpName/tmpName.module";
import {OrganizationService} from "./_service/organization.service";
import {AliasGuard} from "./tmpName/alias.guard";
import {ButtonsModule, TabsModule} from "ngx-bootstrap";
import {AcademWidgetComponent} from "./widget/payment-widget/academ-widget/academ-widget.component";
import {DefaultWidgetComponent} from "./widget/payment-widget/default-widget/default-widget.component";
import {WidgetComponent} from "./widget/payment-widget/widget.component";
import {NguiAutoCompleteModule} from "@ngui/auto-complete";
import {RequestService} from "./main-page/request-part/request.service";
import {AddressSearcherModule} from "./_commonComp/address-searcher/address-searcher.module";
import {MetrikaModule} from "ng-yandex-metrika";
import {LoaderService} from "./_service/loader.service";
import {IntegrationComponent} from "./integration/integration.component";
import {WidgetHelperModule} from "./widget/payment-widget/widget-saldo-info.module";
import {HashCheckComponent} from "./main-page/setting-part/hash-check/hash-check.component";
import {DateService} from './_service/date.service';
import {SendValuesWidgetComponent} from './widget/send-values-widget/send-values-widget.component';
import {MeterWidgetAuthComponent} from './widget/send-values-widget/auth/auth.component';
import {MeterValueService} from './widget/send-values-widget/meter-value.service';
import {SharedModule} from "./shared-module/shared.module";
import {FlashMessagesService} from 'angular2-flash-messages';
import {AliasWithoutStorageGuard} from "./tmpName/alias-without-storage.guard";
import {MeteringUnitConversionService} from './_service/metering-unit-conversion.service';
import {AliasWithoutActiveCheckGuard} from "./tmpName/alias-without-active-check.guard";
import {InactiveInfoComponent} from "./tmpName/inactive-info/inactive-info.component";
import {PipesModule} from "./pipe/pipes-module";
import {PhoneFormatterService} from "./_service/phone-formatter-service/phone-formatter.service";
import {PopupMessageModule} from "./_commonComp/popup-message/popup-message.module";

@NgModule({
  declarations: [
    AppComponent,
    WidgetComponent,
    DefaultWidgetComponent,
    AcademWidgetComponent,
    InactiveInfoComponent,
    IntegrationComponent,
    HashCheckComponent,
    SendValuesWidgetComponent,
    MeterWidgetAuthComponent,
  ],
  imports: [
    WidgetHelperModule,
    PipesModule,
    BrowserModule,
    HttpModule,
    FormsModule,
    MainRoutingModule,
    TmpNameModule,
    ReactiveFormsModule,
    AddressSearcherModule,
    NguiAutoCompleteModule,
    BrowserModule,
    TabsModule.forRoot(),
    ButtonsModule.forRoot(),
    MetrikaModule.forRoot(
      {id: 47024103, webvisor: true}, // CounterConfig | CounterConfig[]
      // defaultCounter?: number | string // ����� ������ �� ��������, ���� ���������� ����� � �������.
    ),
    SharedModule,
    PopupMessageModule
  ],
  providers: [
    AuthGuard,
    HttpService,
    AppComponent,
    PasswordService,
    OrganizationService,
    RequestService,
    FlashMessagesService,
    AliasGuard,
    AliasWithoutActiveCheckGuard,
    AliasWithoutStorageGuard,
    Title,
    LoaderService,
    DateService,
    {provide: LOCALE_ID, useValue: "ru-RU"},
    MeterValueService,
    MeteringUnitConversionService,
    PhoneFormatterService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/app.module.ts